import React, { Component } from 'react';

import PageContent from '~/js/components/specials/specials-by-resort/PageContent/PageContent.js';

const internals = {};

internals.resorts = ['BNG', 'BBO', 'BTC'];

export default class SpecialsByResort extends Component {
    static defaultProps = {
      minimumRates: {},
      percentageOff: [],
      promotions: [],
      resortsSummary: {},
      resortsSlider: {},
      lastMinuteDeals:{}
    }

    constructor(props) {
      super(props);

      this.state = {
        selected: 'view-all',
        deviceWidth: window.innerWidth
      };
    }

    componentDidMount = () => {
      const { deviceWidth } = this.state;

      window.addEventListener('resize', () => {

        if (window.innerWidth !== deviceWidth) {
          this.setState({ deviceWidth: window.innerWidth });
        }
      });
    }

    render() {
      if (Object.keys(this.props.minimumRates).length === 0) {
        return (<div />);
      }
      
      const { minimumRates, percentageOff, promotions, resortsSummary, resortsSlider, cdnURL, countdown, lastMinuteDeals } = this.props;
      
      return (
        <div>
          <PageContent
            selected={this.state.selected}
            resorts={internals.resorts}
            minimumRates={minimumRates}
            percentageOff={percentageOff}
            promotions={promotions}
            resortsSummary={resortsSummary}
            resortsSlider={resortsSlider}
            cdnURL={cdnURL}
            countdown={countdown}
            lastMinuteDeals={lastMinuteDeals}
         
          />
        </div>
      );
    }
}
